export default __webpack_public_path__ + "static/blowjob-68b7bbfe93b3787a125e56381e1994b0.svg";